import { Clock3, File, HardDrive } from 'lucide-react'
import type { AudioTrack } from '../../../api'
import type { AudioTrackMetadataItem } from '../formatAudioMetadata'

export const metadataIcons: Record<AudioTrackMetadataItem['key'], typeof File> = {
  format: File,
  size: HardDrive,
  duration: Clock3
}

export const trackEditorHeaderMeta = (track: AudioTrack): string | null => {
  const artist = track.artist?.trim()

  if (artist) {
    return artist
  }

  if (!track.file_url) {
    return 'Lossless-only source'
  }

  try {
    const pathname = new URL(track.file_url, window.location.href).pathname
    const segment = pathname.split('/').filter(Boolean).pop()

    return segment ? decodeURIComponent(segment) : null
  } catch {
    return null
  }
}

export const formatBpmValue = (bpm: number): string =>
  Number.isInteger(bpm) ? bpm.toFixed(0) : bpm.toFixed(1)
